<rek-alert *ngIf="justLoggedOut" [icon]="'flaticon2-check-mark kt-font-success'" [text]="'SHARED.LOGOUT.SUCCESS' | translate"></rek-alert>
<rek-alert *ngIf="isEnrollmentInactiveInfo" [icon]="'flaticon-warning kt-font-danger'" [text]="'SHARED.ERRORS.FUNCTIONALITY-UNAVAILABLE-INACTIVE-ENROLLMENT' | translate"></rek-alert>

<rek-alert
  *ngIf="justRedirectMyInterviews"
  [icon]="'flaticon-exclamation-1'" 
  [text]="'SHARED.ERRORS.ACCESS-DENIED' | translate: { moduleName: 'DASHBOARD.MY-INTERVIEWS.PAGE-TITLE' | translate}"
  [additionalClasses]="'alert-danger'"
  [isClosable]="false">
</rek-alert>

<router-outlet></router-outlet>